export const APP_NAME = 'kindbody';



// WEBPACK FOOTER //
// ./src/config.js